import { render } from "./LabelManager.vue?vue&type=template&id=3f166aba&scoped=true"
import script from "./LabelManager.vue?vue&type=script&lang=js"
export * from "./LabelManager.vue?vue&type=script&lang=js"

import "./LabelManager.vue?vue&type=style&index=0&id=3f166aba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f166aba"]])

export default __exports__